// ErrorDisplay.jsx
// Modern error display component with professional alert design

import React from 'react';
import { styles } from './styles';
import { AlertIcon } from '../../components/Icons';

const ErrorDisplay = ({ errorMsg }) => {
  if (!errorMsg) return null;

  return (
    <div style={styles.errorSection}>
      <div style={styles.errorContainer}>
        <AlertIcon 
          size={20} 
          color="#CE1126" 
          style={styles.errorIcon}
        />
        <div>
          <p style={styles.errorText}>
            {errorMsg}
          </p>
          {navigator.onLine === false && (
            <p style={styles.offlineIndicator}>
              Browser reports you are offline. Please check your internet connection.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;